
import { Box, Heading, Text, Input, Button, VStack, FormControl, useToast, Stack, } from '@chakra-ui/react';
import { useState } from 'react';
import SocialLinks from './SocialLinks';

export default function Newsletter() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8001";

    const handleSubmit = async () => {
        if (!email) {
            toast({
                title: 'Please enter a valid email address.',
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/newsletter/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Client-App': 'swiftcredit',
                },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (response.ok && data.status === 'success') {
                toast({
                    title: 'Subscribed successfully!',
                    description: 'You’ll now receive updates from us.',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
                setEmail('');
            } else {
                toast({
                    title: 'Subscription failed',
                    description: data.message || 'An error occurred.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: 'Network error',
                description: 'Could not connect to server.',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };
    return ( 
        <Stack
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 8, md: 12 }}
            justify="space-between"
            align="center"
            py={{ base: 10, md: 14 }}
            px={{ base: 6, md: 10 }}
            bg="white"
        >
            <Box
                py={10}
                px={6}
                borderRadius="lg"
                boxShadow="md"
                w="100%"
                maxW={{ base: "100%", md: "600px" }}
                alignContent="flex-start"
            > 
                <VStack spacing={6} align="stretch"> 
                    <Heading size="md" textAlign="center"> 
                        Stay updated with Swift Credit
                    </Heading> 
                    <Text textAlign="center" color="gray.600"> 
                        Sign up to receive the latest updates on interest rates, products, offers etc.
                    </Text> 
                    <Stack direction={{ base: "column", sm: "row" }} spacing={4}>
                        <FormControl> 
                            <Input id="email" type="email" placeholder="Email address" 
                                value={email} onChange={(e) => setEmail(e.target.value)} bg="white" 
                            /> 
                        </FormControl>
                        <Button
                            w={{ base: "100%", sm: "auto" }}
                            bg="black"
                            color="white"
                            _hover={{ bg: "gray.800" }}
                            onClick={handleSubmit}
                            isLoading={loading}
                        >
                            Subscribe
                        </Button>
                    </Stack>
                </VStack> 

            </Box>
            {/*<SocialLinks />*/}
        </Stack>
         ); }